import { Navigate } from "react-router-dom";
import { isFoundationAuthenticated } from "../utils/foundationPackAuth";

export const ProtectedFoundationRoute = ({ children }) => {
    let isAuth = isFoundationAuthenticated();
    return isAuth ? children : <Navigate to="/*" />;;
}
